import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getAccountInfoRes } from "core/http/service/accountInfo/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getAccountInfoRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    avatar: "",
    avatarBirthday: "",
    employeeCode: "",
    fullName: "",
    titleName: "",
    manager: null,
    totalLeaveDay: 0,
    remainingLeaveDay: 0,
    notiActive: false,
    masterAccount: "",
  },
};

const accountInfoSlice = createSlice({
  name: "getAccountInfo",
  initialState,
  reducers: {
    getAccountInfoStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getAccountInfoSuccess: (
      state,
      action: PayloadAction<getAccountInfoRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    setAccountInfo: (
      state,
      action: PayloadAction<Partial<getAccountInfoRes>>
    ) => {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    getAccountInfoFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetAccountInfo: () => {
      return { ...initialState };
    },
  },
});

export const {
  getAccountInfoStart,
  getAccountInfoSuccess,
  getAccountInfoFailed,
  setAccountInfo,
  resetAccountInfo,
} = accountInfoSlice.actions;

export default accountInfoSlice.reducer;
